import React from 'react';
import { EditFormContentTemplate } from 'themes/components';

function EditFormContent(props) {
    return <EditFormContentTemplate {...props} />
}

export default EditFormContent;